import { FormControl, Grid, withStyles } from "@material-ui/core";

const styles = (theme) => ({
  container: {
    padding: 20,
    border: "1px solid #CCCDD2",
    backgroundColor: "#fff",
  },
  title: {
    ...theme.typography.h6,
    margin: 0,
    paddingLeft: 20,
    paddingRight: 20,
    fontFamily: "Sofia-bold",
    fontSize: '1.2rem',
    color: '#333',
  },
  formControl: {
    maxWidth: "100%",
    '& .MuiOutlinedInput-root': {
      fontFamily: 'Sofia',
      backgroundColor: 'transparent',
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
        borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
        borderRadius: 0,
      },
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
          borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
          borderRadius: 0,
        },
      },
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
          borderBottom: '2px solid #7F2062',
          borderRadius: 0,
        },
      },
    },
    '& .MuiSelect-select': {
      fontFamily: 'Sofia',
      padding: '12px 0',
      paddingRight: '32px',
      fontSize: '1rem',
      color: '#666',
    },
  },
});

function AccountSelectContainer({ children, classes }) {
  return (
    <Grid item xs={12}>
      <div className={classes.container}>
        <Grid
          container
          direction="column"
          wrap="nowrap"
          style={{ height: "100%" }}
          alignItems="stretch"
        >
          <Grid item style={{ marginBottom: 10 }}>
            <Grid container direction="row">
              <Grid item>
                <div className={classes.title}>Account</div>
              </Grid>
            </Grid>
          </Grid>

          <Grid item style={{ paddingLeft: 30, paddingRight: 30 }}>
            <Grid container direction="row">
              <Grid item style={{ flexGrow: 1, marginRight: 20 }}>
                <FormControl fullWidth className={classes.formControl}>
                  {children}
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Grid>
  );
}
export default withStyles(styles)(AccountSelectContainer);
